import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "brokerages",
  initialState: {
    list: [],
    selectedBrokerage: null,
    usercounts: null,
    isAddBrokerageModalOpen: false,
    csvJson: [],
    subscriptionUpdated: {},
  },
  reducers: {
    brokeragesReceived: (brokerages, action) => {
      brokerages.list = action.payload;
    },
    brokerageSelected: (brokerages, action) => {
      brokerages.selectedBrokerage = action.payload;
    },
    brokerageUserCountsAdded: (brokerages, action) => {
      brokerages.usercounts = action.payload;
    },
    AddBrokerageModalToggled: (brokerage, action) => {
      brokerage.isAddBrokerageModalOpen = action.payload.status;
    },
    brokeragesReport: (brokerage, action) => {
      brokerage.csvJson = action.payload;
    },
    subscriptionUpdate: (brokerage, action) => {
      brokerage.subscriptionUpdated = action.payload;
    },
  },
});

export const {
  brokeragesReceived,
  brokerageSelected,
  brokerageUserCountsAdded,
  AddBrokerageModalToggled,
  brokeragesReport,
  subscriptionUpdate
} = slice.actions;

export default slice.reducer;

// action creator
export const loadBrokerages = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages",
    method: "get",
    data: data,
    onSuccess: brokeragesReceived.type,
  });

export const addBrokerage = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokerages/add",
    method: "post",
    data: data,
    //   onStart: detailsUpdating.type,
    //   onSuccess: detailsUpdated.type,
    //   onError: detailsUpdateFailed.type,
  });

export const getReport = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages/getReport?type=" + data,
    method: "get",
    onSuccess: brokeragesReport.type,
    onError: false,
  });

export const loadUserCounts = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages/usercounts",
    method: "get",
    onSuccess: brokerageUserCountsAdded.type,
  });

export const updateSubscription = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokerages/update-subscription",
    method: "post",
    data: data,
    // onStart: detailsUpdating.type,
    onSuccess: subscriptionUpdate.type,
    // onError: detailsUpdateFailed.type,
  });

export const getBrokeragesList = createSelector(
  (state) => state.entities.brokerages,
  (brokerages) => brokerages?.list
);

export const getBrokeragesUserCounts = createSelector(
  (state) => state.entities.brokerages,
  (brokerages) => brokerages?.usercounts
);

export const getBrokeragesReport = createSelector(
  (state) => state.entities.brokerages,
  (brokerages) => brokerages?.csvJson
);

export const getSelectedBrokerage = createSelector(
  (state) => state.entities.brokerages,
  (brokerages) => brokerages?.selectedBrokerage
);

export const toggleAddBrokerageModal = createAction(
  AddBrokerageModalToggled.type,
  function toggle(toggleFlag) {
    return {
      payload: {
        status: toggleFlag,
      },
    };
  }
);

export const getAddBrokerageStatus = createSelector(
  (state) => state.entities.brokerages,
  (brokerages) => brokerages?.isAddBrokerageModalOpen
);
export const getSubscribeUpdate = createSelector(
  (state) => state.entities.brokerages,
  (brokerages) => brokerages?.subscriptionUpdated
);
